import { TextField } from '@mui/material'
import React from 'react'
import { Controller } from 'react-hook-form'
import './style.css'
export const Input = ({ name, classAttr, control, rules, label, inputProps, ...rest }) => {
  return (
    <div className={classAttr} style={{ margin: '10px 10px' }}>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <TextField
            sx={{ bgcolor: 'white' }}
            {...inputProps}
            fullWidth
            size="small"
            onChange={onChange}
            value={value}
            label={label}
            {...rest}
          />
        )}
        {...rest}
        rules={{ ...rules }}
      />
    </div>
  )
}
